document.addEventListener('DOMContentLoaded', () => {
    const searchForm = document.querySelector('.search-form');
    const searchInput = document.querySelector('#search-input');
    const resultsContainer = document.querySelector('#search-results');

    searchForm.addEventListener('submit', function(event) {
        event.preventDefault(); // Prevent the default form submission

        const query = searchInput.value;
        if (query.length < 3) return; // Simple validation

        // Fetch results as a JSON object
        fetch(`/search?q=${encodeURIComponent(query)}&view=json`)
            .then(response => response.json())
            .then(data => {
                displayResults(data.results); // Assuming your custom view returns a results array
            })
            .catch(error => {
                console.error('Error fetching search results:', error);
                resultsContainer.innerHTML = '<p>An error occurred during search. Please try again.</p>';
            });
    });

    function displayResults(results) {
        resultsContainer.innerHTML = ''; // Clear previous results
        if (results.length === 0) {
            resultsContainer.innerHTML = '<p>No products found matching your search.</p>';
            return;
        }

        const list = document.createElement('ul');
        results.forEach(item => {
            const listItem = document.createElement('li');
            listItem.innerHTML = `<a href="${item.url}">${item.title}</a> - ${item.price}`;
            list.appendChild(listItem);
        });
        resultsContainer.appendChild(list);
    }
});
